<div class="flex flex-col w-full h-full">
  <app-breadcrumb class="mb-2" [items]="breadcrumdItems" />

  <div class="flex flex-row gap-4 justify-between mb-8">
    <h1 class="text-light-300 text-3xl font-medium">
      Checkout @if(!isLoading && cart.length){({{ cart.length }})}
    </h1>
  </div>

  @if (!isLoading) {
  <div class="flex flex-col lg:flex-row gap-6 pb-8">
    <!-- Properties to invest -->
    <form
      [formGroup]="form"
      class="flex flex-col flex-[3_1_0%] lg:flex-[2_1_0%] gap-6"
    >
      <div class="flex flex-col gap-6 w-full" formArrayName="amounts">
        @for (item of cart; track $index; let i = $index) {
        <p-card>
          <div class="flex flex-col gap-6">
            <div class="flex flex-col sm:flex-row gap-5">
              <img
                class="rounded-lg h-20 w-32 object-cover"
                [src]="item.property.images[0].url"
                [alt]="item.property.images[0].caption"
              />

              <div class="flex flex-row gap-3 w-full justify-between">
                <div class="flex flex-col gap-3">
                  <h2 class="font-bold text-base text-light-300">
                    {{ item.property.name }}
                  </h2>

                  <div class="flex flex-row gap-6">
                    <div
                      class="flex flex-row gap-1 items-center text-light-100"
                    >
                      <svg-icon
                        src="assets/icons/info.svg"
                        svgClass="h-4 w-4"
                      />
                      <p class="font-medium text-sm">Monthly rent</p>
                    </div>

                    <p class="font-bold text-sm text-light-300">
                      {{ item.monthlyCashflow | customCurrency : currency }}
                    </p>
                  </div>

                  <div class="flex flex-row gap-6">
                    <div
                      class="flex flex-row gap-1 items-center text-light-100"
                    >
                      <svg-icon
                        src="assets/icons/info.svg"
                        svgClass="h-4 w-4"
                      />
                      <p class="font-medium text-sm">Appreciation</p>
                    </div>

                    <p class="font-bold text-sm text-light-300">
                      {{
                        item.property.appreciation | customCurrency : currency
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <p-inputgroup class="h-12.5">
              <p-inputgroup-addon>
                <div class="flex flex-row items-center gap-1">
                  <!-- <svg-icon
                    [src]="
                      'assets/flags/' + item.property.country.icon + '.svg'
                    "
                    svgClass="h-4 w-4 text-light-100"
                  /> -->

                  <span class="font-semibold text-sm text-light-300">
                    {{ currency }}
                  </span>
                </div>
              </p-inputgroup-addon>
              <p-inputnumber [formControlName]="i" />
            </p-inputgroup>
          </div>
        </p-card>
        }
      </div>
    </form>

    <!-- Proceed to payment -->

    @if (cart.length) {
    <div class="flex-[2_1_0%] lg:flex-[1_1_0%]">
      <div class="flex flex-col gap-6 h-fit w-full sticky top-0">
        <p-card class="w-full">
          <div class="flex flex-col gap-8 justify-between w-full p-2">
            <h4 class="font-bold text-xl text-light-300">Wallet:</h4>

            <div
              class="flex flex-row items-center gap-2 border border-light-180 rounded-lg p-3"
            >
              <div
                class="flex flex-row justify-between items-center gap-2 grow"
              >
                <span>Wallet balance</span>
                <span>
                  {{ totalWalletBalance | customCurrency : currency }}
                </span>
              </div>
            </div>

            @if (totalWalletBalance < totalPaymentAmount) {
            <div class="flex flex-col gap-1 items-end">
              <div
                class="flex flex-row gap-1 text-red-100 bg-red-50 px-1.5 py-0.5 rounded-sm border border-red-100"
              >
                <svg-icon
                  src="assets/icons/info.svg"
                  svgClass="h-4 w-4 mt-0.5"
                />
                <p class="text-xs">
                  Insufficient balance! Add money to your wallet to proceed with
                  the investment.
                </p>
              </div>

              <p-fluid>
                <p-button
                  severity="primary"
                  label="Add money"
                  size="small"
                  fluid="true"
                  (onClick)="onAddMoney()"
                />
              </p-fluid>
            </div>
            }
          </div>
        </p-card>

        <p-card class="w-full">
          <div class="flex flex-row gap-2 items-center">
            <p-checkbox [(ngModel)]="confirmTerms" [binary]="true" />

            <p class="text-xs text-light-100">
              By clicking you confirm that you agree with our

              <a
                class="underline"
                href="https://drive.google.com/file/d/1mJiu2kNuYfdkEB7xv5ZiTorlKDYDxL-i/view?usp=sharing"
                target="_blank"
                >Terms & Conditions</a
              >
              ,
              <a
                class="underline"
                href="https://drive.google.com/file/d/1toUqcggOcAVphFBIt5FMmYYMJYNORpFF/view?usp=sharing"
                target="_blank"
                >Key Risks</a
              >

              and

              <span
                class="underline hover:text-blue-150 cursor-pointer"
                (click)="showPaymentTermsDialog = !showPaymentTermsDialog"
                >Payment Terms</span
              >.
            </p>
          </div>

          <p-dialog
            header="Payment Terms"
            [modal]="true"
            [(visible)]="showPaymentTermsDialog"
            [style]="{ width: '576px' }"
          >
            <p>
              Seedio is regulated by the Greek Financial Services Authority,
              which require us to hold your money in segregated client money
              accounts with our bank. You may only deposit funds to your Seedio
              Account from your own bank account or other method of payment
              provided it is in your own name. We do not accept third party
              payments. Credit card payments are only allowed if you have
              qualified as a Professional Investor under the DFSA rules. In
              order to continue accessing your funds, you are required to
              maintain ongoing compliance with our Know Your Customer and Anti
              Money Laundering processes which may change from time to time. You
              will be informed in case you become a High Risk Client. If you
              deposit funds from a third party, or for whatever other reason (as
              determined at our sole discretion) we cannot accept your funds, we
              will be required to void or reverse the transaction and return
              back the monies deposited to the source account or other method of
              payment used less all applicable charges. In such cases, you may
              therefore incur additional fees by your transferring bank, or the
              intermediary bank, on the reversal transaction and the sum you
              receive back may be less than the amount of the original deposit
              to Seedio. Please also note that withdrawals of deposit amounts
              made through electronic card payments that were not invested on
              Seedio will be subject to a penalty charge of up to 2.50% of the
              total amount withdrawn. This charge ONLY applies to the withdrawal
              of non-invested funds, as Seedio pays the 2.50% deposit charge
              from our payment gateway for all electronic card deposits. This
              does not apply to withdrawal of investment returns, such as rent
              or sale proceeds. All withdrawals to international bank accounts
              are subject to a minimum withdrawal amount of EUR 100.
            </p>

            <div class="flex justify-end">
              <p-button
                label="Close"
                [link]="true"
                (onClick)="showPaymentTermsDialog = false"
              />
            </div>
          </p-dialog>
        </p-card>

        <p-fluid>
          <p-button
            severity="primary"
            [label]="
              'Invest ' +
              (totalPaymentAmount | customCurrency : currency : '1.0-0')
            "
            [disabled]="
              totalWalletBalance < totalPaymentAmount ||
              !confirmTerms ||
              totalPaymentAmount <= 0 ||
              (_globalProgressSpinnerService.loading$ | async)
            "
            (onClick)="onInvest()"
          />
        </p-fluid>
      </div>
    </div>
    }
  </div>

  <!-- Show empty cart -->
  @if(!cart.length) {
  <ng-container *ngTemplateOutlet="emptyCart" />
  }

  <!-- Show loader -->
  } @else {
  <ng-container *ngTemplateOutlet="loadingSkeleton" />
  }
</div>

<ng-template #emptyCart>
  <div class="flex flex-col gap-6 w-full h-full items-center justify-center">
    <div
      class="flex flex-col items-center justify-center border-4 border-blue-300 w-24 h-24 rounded-full"
    >
      <svg-icon
        src="assets/icons/cart.svg"
        svgClass="h-14 w-14 text-blue-100"
      />
    </div>

    <h1 class="font-bold text-4xl text-light-300">Your cart is empty</h1>
    <p class="text-xl text-light-300 text-center">
      Looks like you haven’t added any properties in your cart
    </p>

    <p-button
      severity="primary"
      type="submit"
      label="View properties"
      size="large"
      (onClick)="onViewProperties()"
    />
  </div>
</ng-template>

<ng-template #loadingSkeleton>
  <div class="flex flex-col lg:flex-row gap-6">
    <div class="flex flex-col flex-[3_1_0%] lg:flex-[2_1_0%] gap-6">
      @for (_ of [1, 2, 3]; track $index) {
      <p-card>
        <div class="flex flex-row gap-5 mb-3">
          <p-skeleton height="80px" width="150px" />

          <div class="flex flex-col gap-3">
            <p-skeleton height="20px" width="250px" />

            <div class="flex flex-row gap-2">
              <div class="flex flex-col gap-1.5">
                <p-skeleton height="10px" width="100px" />
                <p-skeleton height="10px" width="70px" />
              </div>

              <div class="flex flex-col gap-1.5">
                <p-skeleton height="10px" width="100px" />
                <p-skeleton height="10px" width="70px" />
              </div>
            </div>
          </div>
        </div>

        <p-skeleton height="30px" width="100%" />
      </p-card>
      }
    </div>
    <div class="flex-[2_1_0%] lg:flex-[1_1_0%]">
      <p-card styleClass="min-w-[560px] lg:min-w-0">
        <p-skeleton height="100px" width="100%" />
      </p-card>
    </div>
  </div>
</ng-template>
